var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 75,
    viewBox: "0 0 80 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79.2253,
    height: 75,
    rx: 14,
    fill: "#5A47AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 57H32.8374V42.4167L39 39L45.0934 42.4167V36.5833H32.8374V27.8576H48L61.5 22H27V57Z",
    fill: "#FBD15B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg9);
export default __webpack_public_path__ + "static/media/Img9.8e0e52bcbe9cf87326f1282b9208c3e5.svg";
export { ForwardRef as ReactComponent };